import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
/* Tracking */
import { EngagementHandler } from 'client/engagement-handlers';
import { CrowdsourcedDealsEngagementHandler } from 'client/engagement-handlers/crowdsourced-deals-engagement-handler/crowdsourced-deals-engagement-handler';
/* Models */
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorEntities, VisitorModel } from 'client/data/models/visitor';
import { DealsModel, PATHS as DEALS_PATHS } from 'client/data/models/deals';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
/* Constants */
import { CREATIVE_ID } from 'site-modules/core-page/constants/crowdsourced-deals';
/* Components */
import { CrowdsourcedChart } from 'site-modules/core-page/components/crowdsourced-deals/components/crowdsourced-chart/crowdsourced-chart';
import { CrowdsourcedDealsSavings } from 'site-modules/core-page/components/crowdsourced-deals/components/crowdsourced-deals-savings/crowdsourced-deals-savings';
import { CrowdsourcedDealsModalAsync } from 'client/site-modules/core-page/components/crowdsourced-deals/components/crowdsourced-deals-modal/crowdsourced-deals-modal-async';
import { MinHeightWrapper } from 'client/site-modules/shared/components/min-height-wrapper/min-height-wrapper';

EngagementHandler.register(CrowdsourcedDealsEngagementHandler);

export function CrowdsourcedDealsUI({
  chal = '',
  vehicle = null,
  location = {},
  chartData = null,
  defaultMsrp = 0,
  isMobile = false,
}) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const isChal1 = chal === 'chal-1';

  if (!chartData || chartData?.length < 3) return null;
  return (
    <MinHeightWrapper componentType="CROWDSOURCED_DEALS">
      <div className={classNames('rounded-12 mt-1_5 px-1 px-md-1_5 py-1 bg-white')} data-tracking-parent={CREATIVE_ID}>
        <h2 className="size-24">Who has the best {vehicle?.model?.name} deals?</h2>
        <div className="fw-medium mt-0_5 mb-1_5">
          {isChal1 ? (
            <span>
              <i className="icon-location text-blue-50 me-0_25" aria-hidden />
              Local pricing near {location?.city}, {location?.stateCode}
            </span>
          ) : (
            <span className="fw-medium">Cora knows the best deals near {location?.city}</span>
          )}
        </div>

        <Row>
          <Col xs={12} md={7} className="px-0_5 px-md-0">
            <CrowdsourcedChart chartData={chartData} chal={chal} isMobile={isMobile} />
          </Col>
          <Col xs={12} md={5} className="px-0_5 px-md-0 mt-1_5 mt-md-0">
            <CrowdsourcedDealsSavings
              chal={chal}
              vehicle={vehicle}
              defaultMsrp={defaultMsrp}
              setIsModalOpened={setIsModalOpened}
            />
          </Col>
        </Row>
        {isChal1 && (
          <CrowdsourcedDealsModalAsync isModalOpened={isModalOpened} setIsOpened={setIsModalOpened} vehicle={vehicle} />
        )}
      </div>
    </MinHeightWrapper>
  );
}

CrowdsourcedDealsUI.propTypes = {
  chal: PropTypes.string,
  isMobile: PropTypes.bool,
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  defaultMsrp: PropTypes.number,
  location: VisitorEntities.Location,
  chartData: PropTypes.arrayOf(PropTypes.shape({})),
};

export const propsAreEqual = (prevProps, nextProps) => !(nextProps.chartData || nextProps.defaultMsrp);
export const stateToPropsConfig = {
  location: bindToPath('location', VisitorModel),
  chartData: bindToPath(
    ({ vehicle }) =>
      vehicle?.make?.slug && vehicle?.model.slug && vehicle?.year
        ? DEALS_PATHS.CSD_FRANCHISE_INVENTORY({
            make: vehicle.make.slug,
            model: vehicle.model.slug,
            year: vehicle.year,
          })
        : null,
    DealsModel
  ),
};
export const CrowdsourcedDeals = connectToModel(React.memo(CrowdsourcedDealsUI, propsAreEqual), stateToPropsConfig);
